<script>
export default {
  name: 'H1',
}
</script>

<template>
  <h1 class="tw-text-2xl lg:tw-text-5xl tw-font-bold tw-text-ci-gray-700">
    <slot />
  </h1>
</template>
